// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"DailyProfitPage_inputContainer__2RyJb"};